export const projectAmountTypes = {
  PROJECT: {
    label: "Por proyecto",
    value: "PROJECT",
  },
  ASSIGNMENTS: {
    label: "Por asignaciones",
    value: "ASSIGNMENTS",
  },
  WORDS: {
    label: "Por palabras",
    value: "WORDS",
  },
};
